import React from "react";
import {
  ClockCircleOutlined,
  CalendarOutlined,
  FileTextOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import "./summary.css";
import SummaryCard from "./SummaryCard";

const DashboardSummary = ({
  quickStats = {},
  followUpStats = {},
  activeFilter = {},
  setActiveFilter,
  applyQuickDateFilter,
  applyFollowUpDateFilter,
  clearDateFilters,
}) => {
  return (
    <div className="summary-wrapper">
      {/* QUOTATIONS */}
      <div className="summary-title">Overview</div>
      <div className="summary-grid">
        <SummaryCard
          label="Today"
          value={quickStats.today ?? 0}
          icon={<ClockCircleOutlined />}
          colorClass="green"
          active={activeFilter.type === "quote" && activeFilter.value === 0}
          onClick={() => {
            applyQuickDateFilter(0);
            setActiveFilter({ type: "quote", value: 0 });
          }}
        />

        <SummaryCard
          label="Last 7 Days"
          value={quickStats.last7 ?? 0}
          icon={<CalendarOutlined />}
          colorClass="blue"
          active={activeFilter.type === "quote" && activeFilter.value === 7}
          onClick={() => {
            applyQuickDateFilter(7);
            setActiveFilter({ type: "quote", value: 7 });
          }}
        />

        <SummaryCard
          label="Last 30 Days"
          value={quickStats.last30 ?? 0}
          icon={<FileTextOutlined />}
          colorClass="orange"
          active={activeFilter.type === "quote" && activeFilter.value === 30}
          onClick={() => {
            applyQuickDateFilter(30);
            setActiveFilter({ type: "quote", value: 30 });
          }}
        />

        <SummaryCard
          label="Total"
          value={quickStats.total ?? 0}
          icon={<DatabaseOutlined />}
          colorClass="purple"
          active={activeFilter.type === "quote" && activeFilter.value === "all"}
          onClick={() => {
            clearDateFilters();
            setActiveFilter({ type: "quote", value: "all" });
          }}
        />
      </div>

      {/* FOLLOW UPS */}
      <div className="summary-title">Follow Up Summary</div>
      <div className="summary-grid">
        <SummaryCard
          label="Today"
          value={followUpStats.today ?? 0}
          icon={<ClockCircleOutlined />}
          colorClass="pink"
          active={activeFilter.type === "followup" && activeFilter.value === 0}
          onClick={() => {
            applyFollowUpDateFilter(0);
            setActiveFilter({ type: "followup", value: 0 });
          }}
        />

        <SummaryCard
          label="Upcoming 7 Days"
          value={followUpStats.next7 ?? 0}
          icon={<CalendarOutlined />}
          colorClass="teal"
          active={activeFilter.type === "followup" && activeFilter.value === 7}
          onClick={() => {
            applyFollowUpDateFilter(7);
            setActiveFilter({ type: "followup", value: 7 });
          }}
        />

        <SummaryCard
          label="Upcoming 30 Days"
          value={followUpStats.next30 ?? 0}
          icon={<FileTextOutlined />}
          colorClass="red"
          active={activeFilter.type === "followup" && activeFilter.value === 30}
          onClick={() => {
            applyFollowUpDateFilter(30);
            setActiveFilter({ type: "followup", value: 30 });
          }}
        />

        <SummaryCard
          label="All"
          value={followUpStats.total ?? 0}
          icon={<DatabaseOutlined />}
          colorClass="purple"
          active={activeFilter.type === "followup" && activeFilter.value === "all"}
          onClick={() => {
            clearDateFilters();
            setActiveFilter({ type: "followup", value: "all" });
          }}
        />
      </div>
    </div>
  );
};

export default DashboardSummary;
